import { useUser } from 'components/providers/UserProvider'
import { useLazyForageState } from 'lib/hooks/useLazyForageState'
import { FetchedStockInterface } from 'lib/hooks/useStockStore'
import { createInventoryArticle } from 'shared'
import { ElementWithChildren } from 'types'
import { ExistingStockContext } from '../addArticles/useExistingStockContext'

export const ExistingStockProvider = ({ children }: ElementWithChildren): JSX.Element => {
  const { user } = useUser()

  const [stockState, , , loadStock] = useLazyForageState<FetchedStockInterface>(
    { stock: [], sealedStock: [], fetchedAt: new Date().toISOString() },
    `${user?.cardmarketUsername}-stock`,
    {
      duckFunction: (value) => value.stock.find((article) => article.card._id),
      hydrate: (value) => ({
        ...value,
        stock: value.stock.map((article) => createInventoryArticle(article)),
      }),
    }
  )

  return (
    <ExistingStockContext.Provider
      value={{
        stockState,
        loadStock,
      }}
    >
      {children}
    </ExistingStockContext.Provider>
  )
}
